// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1s6O5","bigColWidth":"Table_bigColWidth__3e--i","biggerColWidth":"Table_biggerColWidth__3ukqt","row":"Table_row__2HGDO","col":"Table_col__2yyDW"};